import { api } from "@/lib/api";
import type { ScopedParams } from "./common";
import type { PersonalStatsDto, PointsBreakdownDto, TeamStatsDto } from "@/types/api";

export const statsApi = {
  personal: ({ leagueId, tournamentId }: ScopedParams) =>
    api.get<PersonalStatsDto>("/api/stats/personal", { leagueId, tournamentId }),
  pointsBreakdown: ({ leagueId, tournamentId }: ScopedParams, userId?: string) =>
    api.get<PointsBreakdownDto>("/api/stats/points-breakdown", { leagueId, tournamentId, userId }),
  teamStats: (teamId: string, { leagueId, tournamentId }: ScopedParams) =>
    api.get<TeamStatsDto>(`/api/teams/${teamId}/stats`, { leagueId, tournamentId }),
};
